'use strict';

const _ = require('lodash');
const mergeEnumerable = require('../extensions/lodash.js').mergeEnumerable;

function prototypeComparison(a, b) {

    if (a && a.constructor === Array && b && b.constructor === Array) {
        if (a.length !== b.length) {
            return false;
        }
        let i = 0;
        while (i < a.length) {
            if (!prototypeComparison(a[i], b[i])) {
                return false;
            }
            i++;
        }

        return true;
    }

    if (a && a.constructor === Object && b && b.constructor === Object) {
        return _.isEqual(mergeEnumerable(a), mergeEnumerable(b));
    }

    return _.isEqual(a, b);
}

module.exports = {
    prototypeComparison: prototypeComparison
};
